<template>
  <div
    v-if="isOpen"
    class="delete-chat-overlay"
    @click.self="handleCancel"
  >
    <div class="delete-dialog-card">
      <div class="delete-dialog-title">
        Delete chat
      </div>

      <div class="delete-dialog-message">
        Are you sure you want to delete this chat?
      </div>

      <div class="actions-container">
        <button
          type="button"
          class="cancel-button"
          @click="handleCancel"
        >
          Cancel
        </button>

        <button
          type="button"
          class="delete-button"
          @click="handleConfirm"
        >
          Delete
          <v-icon
            size="16"
            class="delete-icon"
          >
            mdi-trash-can
          </v-icon>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeleteChatDialog',

  props: {
    open: {
      type   : Boolean,
      default: false
    }
  },

  computed: {
    isOpen () {
      return this.open
    }
  },

  methods: {
    handleCancel () {
      this.$emit('cancel')
    },

    handleConfirm () {
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped>
.delete-chat-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(28, 56, 128, 0.24);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  border-radius: 20px 0 0 20px;
  overflow: hidden;
}

.delete-dialog-card {
  display: inline-block;
  width: max-content;
  min-width: 0;
  border-radius: 8px;
  background: #F4F7FF;
  box-shadow: 0 4px 16px rgba(4, 31, 48, 0.16);
}

.delete-dialog-title {
  padding: 14px 16px 12px;
  color: #041F30;
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
}

.delete-dialog-message {
  padding: 0 16px 32px;
  color: #041F30;
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 700;
  line-height: 14px;
  white-space: nowrap;
}

.actions-container {
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 8px 16px 14px;
  margin-bottom: 8px;
}

.cancel-button {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  color: #041F30;
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s ease;
  border: none;
  background: transparent;
}

.delete-button {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  background: #ffffff;
  color: #041F30;
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s ease;
  border: none;
}

.cancel-button:hover {
  border-color: #DFE3EB;
  background: #FFFFFF;
  box-shadow: 0 2px 8px rgba(4, 31, 48, 0.12);
  transform: translateY(-1px);
}

.delete-button:hover {
  border-color: #DFE3EB;
  background: #FBE1E1;
  box-shadow: 0 2px 8px rgba(4, 31, 48, 0.12);
  transform: translateY(-1px);
}

.delete-icon {
  color: #E52C2C;
}
</style>
